export default "__VITE_ASSET__8ny6O0gn__"